import { FilterValueType } from "@/components/StructuredSearch/config/structured-search-schema";
import type { Filter } from "@/components/StructuredSearch/config/types";

interface BuildPromptVersionLockedFiltersInput {
  promptId?: string;
  promptName?: string;
  promptVersionNumber?: number;
}

export const buildPromptVersionLockedFilters = ({
  promptId,
  promptName,
  promptVersionNumber,
}: BuildPromptVersionLockedFiltersInput): Filter[] => {
  if (!promptId || !promptName || promptVersionNumber === undefined) {
    return [];
  }

  return [
    {
      id: `prompt-${promptId}-version-${promptVersionNumber}`,
      field: "prompt_id",
      type: FilterValueType.Prompt,
      operator: "is",
      value: {
        prompt_id: Number(promptId),
        prompt_version_number: promptVersionNumber,
      },
      valueDisplay: `${promptName} [#${promptVersionNumber}]`,
    },
  ];
};
